import ReactGA from 'react-ga4';
import InvoiceDetails from '../types/InvoiceDetails';
import { Luci_Shopping_Api_Models_TagModel } from '../types/api/v7.1/models/Luci_Shopping_Api_Models_TagModel';

export default function GAEvent(actionName: string, tenantId: number): void {
  ReactGA.event({
    action: `Invoice - ${actionName}`,
    category: 'Invoice Portal',
    label: `tenantId:${tenantId} - Invoice Portal`,
  });
}

export function GATransactionEvent(
  invoiceDetails: InvoiceDetails,
  type: 'add_to_cart' | 'remove_from_cart' | 'begin_checkout' | 'purchase'
): void {
  // Early return if order is undefined
  if (!invoiceDetails.order) {
    // eslint-disable-next-line no-console
    console.warn('Cannot send GA transaction event: order details missing');
    return;
  }

  const {
    id,
    lineItemSubtotal,
    shippingAmount,
    salesTaxAmount,
    tenantId,
    orderItems,
  } = invoiceDetails.order;

  // Handle case where orderItems might be undefined
  const orderItemsArray = orderItems ?? [];

  const formattedLineItems = orderItemsArray.map((lineItem) => {
    const itemDetails: { [key: string]: string } = {};

    // Check if lineItem and tags exist before accessing
    if (lineItem) {
      const tags = lineItem.tags ?? [];
      tags.forEach((tag: Luci_Shopping_Api_Models_TagModel, i: number) => {
        if (tag && tag.name) {
          itemDetails[`item_category${i === 0 ? '' : i + 1}`] = tag.name;
        }
      });

      return {
        item_id: lineItem.sku ?? '',
        item_name: lineItem.name ?? '',
        quantity: lineItem.quantity ?? 0,
        ...itemDetails,
      };
    }

    // Return default empty item if lineItem is null/undefined
    return {
      item_id: '',
      item_name: '',
      quantity: 0,
      ...itemDetails,
    };
  });

  ReactGA.gtag('event', type, {
    transaction_id: id ?? '',
    currency: 'USD',
    value: lineItemSubtotal ?? 0,
    tax: salesTaxAmount ?? 0,
    shipping: shippingAmount ?? 0,
    affiliation: `Tenant Id: ${tenantId ?? 'unknown'}`,
    items: formattedLineItems,
  });
}
